<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <el-form :model="formData" :inline="true" size="mini" label-width="auto">
          <el-form-item style="float: right;">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
          </el-form-item>
          <el-form-item label="SPU名称" prop="spuName">
            <el-input v-model="formData.spuName" placeholder="请输入SPU名称"></el-input>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main ref="main">
        <div>
          <el-tag type="primary" size="small" class="tag" closable @close="handleTagClose(item)"
            v-for="(item, index) in flatSelectionData" :key="index">
            {{item.spuName}}
          </el-tag>
        </div>
        <el-table
          stripe
          border
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          :data="tableData"
          :height="tableHeight"
          :row-class-name="tableRowClassName"
          @select="handleSelect"
          @select-all="handleSelectAll"
          v-if="tableHeight"
          v-loading="loading"
          ref="elTable"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip></el-table-column>
          <el-table-column label="更新说明" prop="instruction" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.instruction" v-if="scope.row.disable"></el-input>
              <span v-else>{{scope.row.instruction}}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" prop="updateDate" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作人" prop="operator" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" fixed="right" width="110px" align="center">
            <template slot-scope="scope" v-if="scope.row.fileId">
              <el-link
                :underline="false"
                type="primary"
                @click="edit(scope.row)"
                v-if="!scope.row.disable">调整</el-link>
              <template v-else>
                <el-link :underline="false" type="primary" @click="cancel(scope.row)">取消</el-link>
                <el-link :underline="false" type="primary" @click="save(scope.row)">保存</el-link>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import tableSelect from './table-select.mixin'
  export default {
    mixins: [tableSelect],
    data() {
      return {
        tableHeight: 200,
        loading: false,
        formData: {},
        tableData: [],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      handleSearch(data) {
        this.allSelectionData = [];
        this.paginationOpt.pageNum = 1;
        this.formData = data;
        this.init();
      },
      init() {
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData
          }
        };
        this.$q.newProduct.spuFileListPage({data: formData})
        .then(res=>{
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
          this.showCheckedNode();
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      },
      onSearch() {
        this.handleSearch(this.formData);
      },
      onReset() {
        this.formData = {};
        this.handleSearch(this.formData);
      },
      tableRowClassName({row, rowIndex}) {
        if(row.disable) {
          return 'success-row'
        }else{
          return ''
        }
      },
      edit(row) {
        this.tableData.forEach(item=>{
          this.$set(item, 'disable', false)
        })
        this.$set(row, 'disable', true)
      },
      cancel(row) {
        row.disable = false;
      },
      save({ disable, fileId, spuId, instruction }) {
        this.$q.newProduct.updateInstructions({params: {
          fileId, spuId,
          updateInstructions: instruction
        }})
        .then(res=>{
          if(res.code == 200) {
            this.$message.success('保存成功')
          }else{
            this.$message.error(res.message)
          }
        })
        .catch(err=>{
          this.$message.error(err.message)
        })
        .finally(_=>{
          this.tableData.forEach(item=>{
            this.$set(item, 'disable', false)
          })
          this.init();
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  >>> .el-header
    position relative
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px

  >>> .el-table
    td
      height 26px
    .success-row
      background #f0f9eb
      td
        height 40px
        transition all linear .2s
        .el-input input
          height 30px
          width 100%
  
  >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 100%
  .date-input
    width 200px !important

  >>> .el-form-item
    margin-bottom 0 !important

  .tag
    max-width 200px
    overflow hidden
    text-overflow ellipsis
    position relative
    padding-right 20px
    margin-right 5px
    >>> .el-tag__close
      position absolute
      right 3px
      top 3px 
      z-index 10
</style>